import React, { useState, useEffect } from 'react';
import {Container, Card, Form, Button, Alert, ListGroup, Nav} from 'react-bootstrap';
import {Link, useNavigate} from 'react-router-dom';
import AppNavbar from './Navbar';
import MobileNavbar from './MobileNavbar';
import CalendarIntegrations from './CalendarIntegrations'; // Import the new component
import { useAuth } from '../contexts/AuthContext';
import { useDevice } from '../contexts/DeviceContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSignOutAlt,
    faCog,
    faUserCircle,
    faCode,
    faServer,
    faSave,
    faPlugCirclePlus,
    faPlus,
    faBell,
    faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import {useEnvironment} from "../contexts/EnvironmentContext.jsx";
import {useNavigation} from "@/services/useNavigation.js";
import { useNotifications } from '../contexts/NotificationContext';
import NotificationPrompt from './NotificationPrompt';
import head from "@/assets/images/robothead.svg";

const Settings = () => {
    const {
        environment,        // 'development' or 'production'
        isDevelopment,      // boolean flag
        isProduction,       // boolean flag
        apiEndpoints,       // object with API endpoints
        changeEnvironment   // function to change environment
    } = useEnvironment();

    const { user, logout } = useAuth();
    const { isMobile } = useDevice();
    const navigate = useNavigate();
    const [current_environment, setCurrentEnvironment] = useState('production');
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [showConfirmLogout, setShowConfirmLogout] = useState(false);
    const [activeComponent, setActiveComponent] = useState('settings');

    const { handleNavItemClick } = useNavigation();

    // Load saved settings on component mount
    useEffect(() => {
        const savedEnv = localStorage.getItem('appEnvironment');
        console.log('user----->',user);
        if (savedEnv) {
            setCurrentEnvironment(savedEnv);
        }
    }, []);

    const handleSaveSettings = () => {
        try {
            // Save settings to localStorage
            localStorage.setItem('appEnvironment', current_environment);
            changeEnvironment(current_environment);
            // Show success message
            setSaveSuccess(true);
            setSaveError('');

            // Hide success message after 3 seconds
            setTimeout(() => {
                setSaveSuccess(false);
            }, 3000);
        } catch (error) {
            console.error('Error saving settings:', error);
            setSaveError('Failed to save settings. Please try again.');
            setSaveSuccess(false);
        }
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Error logging out:', error);
            setSaveError('Failed to log out. Please try again.');
        }
    };


    return (
        <div className="dashboard-wrapper">
            {/* Regular Navbar for Desktop */}
            <div className="d-none d-md-block">
                <AppNavbar />
            </div>

            {/* Mobile Navbar */}
            <MobileNavbar
                onNavItemClick={handleNavItemClick}
                activeItem={activeComponent}
            />

            <Container className="py-4">
                {saveSuccess && (
                    <Alert variant="success" className="mb-4">
                        Settings saved successfully!
                    </Alert>
                )}

                {saveError && (
                    <Alert variant="danger" className="mb-4">
                        {saveError}
                    </Alert>
                )}

                <Card className="mb-4 shadow-sm">
                    <Card.Header as="h5">
                        <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                        Account Information
                    </Card.Header>
                    <Card.Body>
                        <ListGroup variant="flush">
                            <ListGroup.Item>
                                <strong>Email:</strong> {user?.email}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <strong>User ID:</strong> {isMobile ? `${user?.id?.substring(0, 10)}...` : user?.id}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <strong>Last Login:</strong> {new Date().toLocaleString()}
                            </ListGroup.Item>
                        </ListGroup>
                    </Card.Body>
                </Card>

                <CalendarIntegrations />

                <Card className="mb-4 shadow-sm">
                    <Card.Header as="h5">
                        <FontAwesomeIcon icon={faBell} className="me-2" />
                        Notifications
                    </Card.Header>
                    <Card.Body>
                        <NotificationPrompt />
                    </Card.Body>
                </Card>

                <Card className="shadow-sm">
                    <Card.Header as="h5" className="text-danger">
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                        Session
                    </Card.Header>
                    <Card.Body>
                        <p>Ready to leave? Click the button below to log out of your account.</p>
                        <Button
                            variant={showConfirmLogout ? "danger" : "outline-danger"}
                            onClick={handleLogout}
                        >
                            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                            {showConfirmLogout ? "Confirm Logout" : "Logout"}
                        </Button>
                    </Card.Body>
                </Card>

                <Card className="mt-4 shadow-sm">
                    <Card.Header as="h5" className="text-muted">
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                        App Info
                    </Card.Header>
                    <Card.Body>
                        <ListGroup variant="flush">
                            <ListGroup.Item>
                                <strong>Version:</strong> {__APP_VERSION__}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <strong>Build:</strong> {__BUILD_TIME__}
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <strong>Environment:</strong> {environment}
                            </ListGroup.Item>
                        </ListGroup>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default Settings;